import styled from 'styled-components';

export const BadgeList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
`;

export const Badge = styled.span<{ $fontSize: number }>`
  display: inline-flex;
  align-items: center;
  font-family: var(--hand);
  font-weight: 700;
  color: #2a2f33;
  letter-spacing: 0.2px;
  white-space: nowrap;
  line-height: 1.2;
  padding: 2px 9px;
  font-size: ${({ $fontSize }) => $fontSize}px;
`;
